export const COMPONENT_NAME = "registration-page";

export enum RegistrationPageComponent {
  form = "form",
  verification = "verification",
  message = "message",
}
